// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.AddFieldSetting.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import UIConstants from 'logic/data/Izenda.UIConstants';
import SettingsByRangeItemFieldModel from 'logic/models/Izenda.SettingsByRangeItemFieldModel';
import AddFieldSelect from './Izenda.AddFieldSelect';

const { isEmpty, isNull, isNil, has } = require('lodash/fp');

export default class AddFieldSetting extends Component {
  /**
   * Open add field popup
   */
  onClick = () => {
    const { fieldModel, dataTree, reportPartContent, fieldContainerName } = this.props;

    this.props
      .openPopup(AddFieldSelect, {
        fieldModel,
        dataTree,
        reportPartContent,
        fieldContainerName
      })
      .then(this.props.onOk);
  };

  /**
   * Get field model UI name.
   */
  getDisplayName(fieldModel: SettingsByRangeItemFieldModel) {
    const { localization } = this.props;
    return isNil(fieldModel) || isNil(fieldModel.displayName)
      ? localization.getText('REPORTDESIGNER_LABEL_ADD_NEW_FIELD')
      : isEmpty(fieldModel.displayName)
        ? UIConstants.MASKED_TEXT
        : fieldModel.displayName;
  }

  render() {
    const { fieldModel, className } = this.props;
    const hasField = !!(fieldModel && fieldModel.fieldId);
    const displayName = this.getDisplayName(fieldModel);
    const containerClassName = ' u_flex u_flexCenterAlignItems ';
    const innerClassName = `${className} form-control overflow-text u_paddingLeft`;

    return (
      <div className={containerClassName}>
        <div className={innerClassName} title={displayName} data-toggle="tooltip" ref="editor">
          {!hasField && (
            <a>
              <span onClick={this.onClick}>{displayName}</span>
            </a>
          )}
          {hasField && <span className="u_curPointer" onClick={this.onClick}>{displayName}</span>}
        </div>

        {hasField && (
          <a className="u_paddingLeft">
            <span className="icon-setting" onClick={this.onClick} />
          </a>
        )}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/CommonSettings/Izenda.AddFieldSetting.js